import React from "react";
import Select from "react-select";
import { useI18n } from "../i18n";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.menuIsOpen ? "var(--surface-md)" : "transparent",
    border: "none",
    boxShadow: "none",
    borderRadius: 8,
    minWidth: 120,
    minHeight: 36,
    cursor: "pointer",
    transition: "background-color 0.15s",
    "&:hover": {
      backgroundColor: "var(--surface-md)",
      border: "none",
    },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "var(--input-bg)",
    border: "1px solid var(--border-md)",
    borderRadius: 8,
    boxShadow: "var(--shadow-floating)",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "var(--accent-g)" : "transparent",
    color: state.isSelected ? "var(--accent)" : "var(--text)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "var(--surface-md)",
      color: "var(--text)",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--muted2)",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "var(--muted)",
  }),
  input: (provided) => ({
    ...provided,
    color: "var(--text)",
  }),
};

export function LanguageSelect() {
  const i18n = useI18n();
  const options = i18n.availableLanguages.map((option) => ({
    ...option,
    label: i18n.t(option.labelKey),
  }));

  return (
    <Select
      value={options.find((o) => o.value === i18n.getLanguage())}
      onChange={(selected) => i18n.changeLanguage(selected.value)}
      options={options}
      styles={customStyles}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      isSearchable={false}
    />
  );
}
